<template>
  <main id="contents" class="main">
    <PpvConfirm />
    <PpvToast />
    <WCampaign :campaign="campaignData" />
    <WCatalog v-if="catalogData" :id="id" :catalog="catalogData" />
  </main>
</template>

<script setup>
  import { ref } from 'vue'
  import { useStore } from '@/common/utils/store'
  import { getHomeData } from '@/common/requests/data-fetch/get-home-data'
  import PpvConfirm from '@/components/movie/PpvConfirm.vue'
  import PpvToast from '@/components/movie/PpvToast.vue'
  import WCatalog from '@/pages/home/WCatalog.vue'
  import WCampaign from '@/pages/home/WCampaign.vue'
  import {
    scrollTop,
    setDisableScrolling,
    titleTagNameChange,
  } from '@/common/utils/common'

  const store = useStore()

  const catalogData = ref(null)
  const campaignData = ref(null)
  const id = ref('')

  const setHome = async () => {
    const { data: homeData } = await getHomeData()

    if (homeData) {
      const { catalog, campaign, category } = homeData?.layout
      catalogData.value = catalog ?? {}
      campaignData.value = campaign ?? {}
      store.commit('setCategory', { category })

      id.value = homeData?.id ?? ''
    }
  }

  const init = () => {
    scrollTop()
    setDisableScrolling(false)
    titleTagNameChange('Wavve(웨이브)')
    setHome()
  }

  init()
</script>
<style lang="scss"></style>
